import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import DynamicPhoneNumber from "common/blocks/DynamicPhoneNumber";
import useModalContext from "common/providers/modal/useModalContext";
import { Sidebar } from "common/providers/modal/useSidebar";
import { valuePartExchangeModal } from "features/vehicleDetails/modals";
import useHasMounted from "hooks/useHasMounted/useHasMounted";

import styles from "./BuyPartExCtas.module.scss";

const cx = classNames.bind(styles);

export type BuyPartExCtasProps = {
    reserveUrl?: string;
    ctaLeftText?: string;
    ctaRightText?: string;
    ctaCallToReservePrefix?: string;
    ctaComingSoonText?: string;
    isDiscounted?: boolean;
    isComingSoon?: boolean;
    openSideBarCallback?: () => Sidebar;
};

const BuyPartExCtas = ({
    reserveUrl,
    ctaLeftText,
    ctaRightText,
    ctaCallToReservePrefix,
    ctaComingSoonText,
    isDiscounted = false,
    isComingSoon = false,
    openSideBarCallback,
}: BuyPartExCtasProps) => {
    const { useSidebar } = useModalContext();
    const { openSidebar } = useSidebar();
    const hasMounted = useHasMounted();

    if (!ctaLeftText && !ctaRightText) return null;
    return (
        <div>
            {isComingSoon && (
                <Button className={cx("reserve-comingsoon")} fullWidth>
                    <DynamicPhoneNumber
                        isLink
                        prefix={ctaCallToReservePrefix}
                        iconName="PhoneEmpty"
                    />
                </Button>
            )}
            <div id="buy-part-ex-ctas" className={cx("buttonRow", { isDiscounted })}>
                {hasMounted && !!ctaLeftText && !isComingSoon && (
                    <Button
                        href={reserveUrl}
                        fullWidth
                        theme="accent"
                        type="button"
                        ariaLabel={ctaLeftText}
                        rel="nofollow"
                    >
                        {ctaLeftText}
                    </Button>
                )}
                {isComingSoon && (
                    <Button
                        fullWidth
                        theme="accent"
                        type="button"
                        onClick={openSideBarCallback && (() => openSidebar(openSideBarCallback()))}
                    >
                        {ctaComingSoonText}
                    </Button>
                )}
                {!!ctaRightText && (
                    <Button
                        fullWidth
                        theme="tertiary"
                        type="button"
                        onClick={() => openSidebar(valuePartExchangeModal)}
                        ariaLabel={ctaRightText}
                    >
                        {ctaRightText}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default BuyPartExCtas;
